(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-video-lazy"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(scope) {
      var wraps = scope.querySelectorAll('[data-lp-video]');

      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.dataset.lpVideoInit) return;
        wrap.dataset.lpVideoInit = 'true';

        var video = wrap.querySelector('video');
        if (!video) return;

        var hydrate = function () {
          if (video.dataset.sourcesLoaded) return;
          Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.dataset.sourcesLoaded = 'true';
          video.load();
        };

        if (wrap.dataset.mode === 'click') {
          var play = function () {
            wrap.classList.add('is-playing');
            video.controls = true;
            hydrate();
            video.play();
          };
          var button = wrap.querySelector('[data-lp-video-play]');
          if (button) button.addEventListener('click', play);
          return;
        }

        /* Autoplay mode. Reduced motion gets a static poster with controls so
           the content stays reachable without anything moving on its own. */
        if (reduced || !('IntersectionObserver' in window)) {
          video.controls = true;
          hydrate();
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                hydrate();
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '100px 0px' }
        );
        observer.observe(video);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
